import { render, staticRenderFns } from "./CardBase.vue?vue&type=template&id=76b966cd&scoped=true&"
import script from "./CardBase.vue?vue&type=script&lang=js&"
export * from "./CardBase.vue?vue&type=script&lang=js&"
import style0 from "./CardBase.vue?vue&type=style&index=0&id=76b966cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b966cd",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b966cd')) {
      api.createRecord('76b966cd', component.options)
    } else {
      api.reload('76b966cd', component.options)
    }
    module.hot.accept("./CardBase.vue?vue&type=template&id=76b966cd&scoped=true&", function () {
      api.rerender('76b966cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/EscolhaPerfil/components/CardBase.vue"
export default component.exports